import { useHandleFavoritesAuth } from '~/features/store';

export default defineNuxtPlugin(() => {
    useHandleFavoritesAuth();
});
